import { getTime } from "../../core/utils";
import constants from "../../core/constants";
import changeDialogCtrl from "./changeDialog/changeDialog.controller";
import changeDialog from "./changeDialog/changeDialog.html";
import conflictingDialogCtrl from "../../components/conflictingDialog/conflictingDialog.controller";
import conflictingDialog from "../../components/conflictingDialog/conflictingDialog.html";
class Controller {
  constructor($injector, $stateParams, $mdDialog, $state) {
    "ngInject";

    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.$stateParams = $stateParams;
    this.Events = $injector.get("Events");
    this.Messages = $injector.get("Messages");
    this.BackupSchedule = $injector.get("BackupSchedule");
    this.BackupScheduleTransforms = $injector.get("BackupScheduleTransforms");

    this.sections = $injector.get("Sections").routesSections;
    this.onUpdateEvent = this.Events.getUpdateEvent("backupschedule");
    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.BackupSchedule.get(this.$stateParams.id).$promise.then(
      (response) => {
        this.backupschedule = this.BackupScheduleTransforms.justify(response);
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );

    this.Events.on(this.onUpdateEvent, this.onUpdate.bind(this));
  }
  showConflictDialog(captainConflict) {
    const timezone = this.backupschedule.city.timezone;
    this.$mdDialog.show({
      controller: conflictingDialogCtrl,
      controllerAs: "$ctrl",
      template: conflictingDialog,
      locals: {
        captainConflict,
        timezone,
      },
    });
  }
  onUpdate(options) {
    const params = {};
    params[options.key] = options.value
      ? options.value
      : options.name
      ? options.name._id
      : null;
    if (options.key === "start_time" || options.key === "end_time") {
      const localTimezone =
        Math.abs(new Date().getTimezoneOffset()) * constants.fromMinToMilli;
      // Difference between local timezone and route city timezone
      const diffTimezone = Math.abs(
        this.backupschedule.city.timezone - localTimezone
      );

      // Get Selected Time with respect of timezone
      const valueWithDiffTimezone =
        localTimezone > this.backupschedule.city.timezone
          ? getTime(params[options.key]) - diffTimezone
          : getTime(params[options.key]) + diffTimezone;

      /* Local timezone and route city timezone are the same, will send selected value
      // Local timezone and route city timezone aren't the same, will respect local timezone
      // handle if difference timezone is negative so need to add 24 hours
      */
      params[options.key] =
        this.backupschedule.city.timezone === localTimezone
          ? getTime(params[options.key])
          : valueWithDiffTimezone < 0
          ? valueWithDiffTimezone + constants.fromDayToMilli
          : valueWithDiffTimezone < constants.fromDayToMilli
          ? valueWithDiffTimezone
          : valueWithDiffTimezone - constants.fromDayToMilli;
    }

    this.BackupSchedule.updateAction(
      this.$stateParams.id,
      options.methodName,
      params
    ).$promise.then(
      (response) => {
        this.backupschedule = this.BackupScheduleTransforms.justify(response);
        this.Events.emit(
          this.showNotificationEvent,
          this.Messages.updateMessage("backup schedule", options.key)
        );
      },
      (response) => {
        if (response.data.captainConflict) {
          const captainConflict = response.data.captainConflict;
          this.showConflictDialog(captainConflict);
        }
        this.Events.emit(this.errorEvent, response.data);
      }
    );
  }

  remove() {
    const confirm = this.$mdDialog
      .confirm()
      .title("Are you sure you want to remove this backup schedule?")
      .ok("Ok")
      .cancel("Cancel");

    this.$mdDialog.show(confirm).then(
      () => {
        this.BackupSchedule.delete(this.$stateParams.id).$promise.then(
          () => {
            this.Events.emit(
              this.showNotificationEvent,
              this.Messages.removeMessage("backup schedule")
            );
            this.$state.transitionTo("backupschedules");
          },
          (response) => {
            if (response.data.captainConflict) {
              const captainConflict = response.data.captainConflict;
              this.showConflictDialog(captainConflict);
            }
            this.Events.emit(this.errorEvent, response.data);
          }
        );
      },
      () => {}
    );
  }

  changeEntity(type) {
    const name = type === "captain" ? "update_captain" : "update_bus_type";
    const change = this.$mdDialog.show({
      controller: changeDialogCtrl,
      controllerAs: "$ctrl",
      template: changeDialog,
      locals: {
        type,
      },
    });

    change.then((data) => {
      this.BackupSchedule.updateAction(
        this.$stateParams.id,
        name,
        data
      ).$promise.then(
        (response) => {
          this.Events.emit(this.showNotificationEvent, {
            message: `${type} changed successfully.`,
          });
          this.backupschedule = this.BackupScheduleTransforms.justify(response);
        },
        (response) => {
          if (response.data.captainConflict) {
            const captainConflict = response.data.captainConflict;
            this.showConflictDialog(captainConflict);
          }
          this.Events.emit(this.errorEvent, response.data);
        }
      );
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/backupSchedule/backupSchedule.controller.js